import * as React from "react"
import Svg, { Circle, Path } from "react-native-svg"

function ManageLimitIconFocused(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
    >
      <Circle cx={12.5} cy={12} r={9} fill="#2D57D9" />
      <Path
        d="M12.5 21.5c-1.3 0-2.53-.25-3.688-.75a9.626 9.626 0 01-3.024-2.038 9.626 9.626 0 01-2.038-3.024A9.205 9.205 0 013 12c0-1.317.25-2.554.75-3.713a9.476 9.476 0 012.037-3.012A9.735 9.735 0 018.813 3.25 9.205 9.205 0 0112.5 2.5c1.317 0 2.554.25 3.712.75a9.582 9.582 0 013.013 2.025 9.582 9.582 0 012.025 3.012c.5 1.159.75 2.396.75 3.713 0 1.3-.25 2.53-.75 3.688a9.735 9.735 0 01-2.025 3.024 9.477 9.477 0 01-3.013 2.038c-1.158.5-2.395.75-3.712.75zm0-1.125c2.333 0 4.313-.817 5.938-2.45 1.625-1.633 2.437-3.608 2.437-5.925 0-2.333-.813-4.313-2.438-5.938-1.625-1.625-3.604-2.437-5.937-2.437-2.317 0-4.292.813-5.925 2.438C4.942 7.688 4.125 9.666 4.125 12c0 2.317.817 4.292 2.45 5.925 1.633 1.633 3.608 2.45 5.925 2.45z"
        fill="#fff"
      />
      <Path
        d="M8.05 11.55l-3.4 3.4c.12.36.4.883.525 1.1L8.6 12.6l2.8 2.375a.526.526 0 00.237.137c.092.025.18.038.263.038a.615.615 0 00.225-.05.993.993 0 00.25-.15l4.55-4.55V12c0 .166.054.304.162.412a.559.559 0 00.413.163.559.559 0 00.412-.163.559.559 0 00.163-.412V9.15c0-.2-.07-.371-.213-.513a.699.699 0 00-.512-.212H14.5a.559.559 0 00-.413.162.559.559 0 00-.162.413c0 .166.054.304.162.412a.559.559 0 00.413.163h1.625l-4.3 4.3-2.8-2.375a.977.977 0 00-.225-.125.505.505 0 00-.275-.025.579.579 0 00-.238.05 1.105 1.105 0 00-.237.15z"
        fill="#fff"
      />
    </Svg>
  )
}

export default ManageLimitIconFocused
